import { cqrs } from '@faro/http-clients';
import { Estimand, toEstimand } from '@faro/study-designer-model';
import axios from 'axios';
import { Identifiable } from 'faro-common-model';
import { RevisionQueryParameter, StudyPathParameter } from '../parameter';

export type EstimandPathParameters = StudyPathParameter;
export type EstimandQueryParameters = RevisionQueryParameter;

const factory = cqrs<Estimand, EstimandPathParameters>('/api/study-designer/studies/:studyId/estimands', toEstimand);

/**
 * Client responsible for accessing the backend entity services
 */
export const estimandClient = {
    list: factory.list<EstimandQueryParameters>(),
    get: async (
        request: EstimandPathParameters & Identifiable & EstimandQueryParameters,
        signal?: AbortSignal
    ): Promise<Estimand> => {
        const { studyId, id, ...params } = request;
        return axios
            .get(`/api/study-designer/studies/${studyId}/estimands/${id}`, { params, signal })
            .then(response => toEstimand(response.data));
    },
};
